import data from './data/imageData.json';
import { imageAsset } from './components/ResponsiveImage';
import siteConfig from './data/siteConfig.json';

export const siteOrigin = siteConfig.origin;
export const pagePaths = ['/', '/portfolio', '/desprenoi', ...data.albums.map(album => `/portfolio/${album.slug}`)];

export function getPageMetadata(pathname: string) {
  const path = pathname.replace(/\/+$/, '') || '/';
  const album = data.albums.find(item => path === `/portfolio/${item.slug}`);
  const pages: Record<string, { title: string; description: string; image: string }> = {
    '/': {
      title: 'Sercons & Contractor | Construcții și portofoliu de proiecte în Tulcea',
      description: 'Descoperiți portofoliul Sercons & Contractor din Tulcea: construcții civile și industriale, amenajări și proiecte realizate în România.',
      image: data.homepage.url,
    },
    '/portfolio': {
      title: 'Portofoliu de construcții | Sercons & Contractor',
      description: 'Explorați proiectele Sercons & Contractor: case, școli, spitale, parcuri și amenajări. Fotografii din lucrările realizate în Tulcea și în țară.',
      image: data.portfoliopage.url,
    },
    '/desprenoi': {
      title: 'Despre noi | Sercons & Contractor, Tulcea',
      description: 'Cunoașteți Sercons & Contractor, companie de construcții din Tulcea înființată în 2018. Aflați despre echipă, activitate și datele de contact.',
      image: data.aboutpage.url,
    },
  };
  const page = album ? {
    title: `${album.name} | Portofoliu Sercons & Contractor`,
    description: `${album.name} — proiect din portofoliul Sercons & Contractor. Descoperiți galeria cu ${album.images.length} fotografii ale lucrărilor de construcții și amenajare.`,
    image: album.cover,
  } : pages[path];
  const canonical = page ? `${siteOrigin}${path}` : null;
  return {
    title: page?.title || 'Pagina nu există | Sercons & Contractor',
    description: page?.description || 'Pagina căutată nu există. Explorați portofoliul de proiecte Sercons & Contractor.',
    canonical,
    image: `${siteOrigin}${page ? imageAsset(page.image).src : '/sercons_logo.png'}`,
    robots: page ? 'index, follow, max-image-preview:large' : 'noindex, follow',
    structuredData: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'GeneralContractor', '@id': `${siteOrigin}/#company`,
          name: 'Sercons & Contractor', url: siteOrigin,
          logo: `${siteOrigin}/sercons_logo.png`,
          email: 'serconscontractor@gmail.com',
          address: { '@type': 'PostalAddress', streetAddress: 'Str. 14 Noiembrie, 5B', addressLocality: 'Tulcea', addressCountry: 'RO' },
          sameAs: ['https://www.facebook.com/profile.php?id=100027726264098'],
        },
        ...(canonical ? [{
          '@type': album || path === '/portfolio' ? 'CollectionPage' : 'WebPage',
          '@id': `${canonical}#webpage`, url: canonical, name: page!.title,
          description: page!.description, inLanguage: 'ro-RO',
          about: { '@id': `${siteOrigin}/#company` },
        }] : []),
      ],
    },
  };
}
